import { useSelector } from 'react-redux';
import { defineMessages } from 'react-intl';
import * as actions from '../../../../state';
import { extraGroup, gaugeGroup } from './gaugeControlList';

const messages = defineMessages({
  GAUGE: {
    id: 'GAUGE',
    defaultMessage: 'Gauge',
  },
  EXTRA: {
    id: 'EXTRA',
    defaultMessage: 'Extra',
  },
  FONT_SIZE: {
    id: 'FONT_SIZE',
    defaultMessage: 'Font Size',
  },
  INNER_RADIUS: {
    id: 'INNER_RADIUS',
    defaultMessage: 'Inner Radius',
  },
  BORDER_WIDTH: {
    id: 'BORDER_WIDTH',
    defaultMessage: 'Border Width',
  },
  MARGIN_BOTTOM: {
    id: 'MARGIN_BOTTOM',
    defaultMessage: 'Margin Bottom',
  },
  MARGIN_TOP: {
    id: 'MARGIN_TOP',
    defaultMessage: 'Margin Top',
  },
  MARGIN_LEFT: {
    id: 'MARGIN_LEFT',
    defaultMessage: 'Margin Left',
  },
  MARGIN_RIGHT: {
    id: 'MARGIN_RIGHT',
    defaultMessage: 'Margin Right',
  },
});

function GaugeStyleControls({ renderControlGroup }) {
  const extraStyleControls = useSelector((state) => actions.selectConfig(state, 'ANALYTICS_EXTRA_STYLE_CONTROLS'));

  // controls by group, used to present controls in like groups
  const controlsGroups = [{
    labelId: 'GAUGE',
    controls: gaugeGroup,
  }];

  if (extraStyleControls) {
    controlsGroups.push({
      labelId: 'EXTRA',
      controls: extraGroup,
    });
  }

  return controlsGroups.map(
    (controlsGroup, cgIndex) => renderControlGroup(controlsGroup, messages, cgIndex),
  );
}

export default GaugeStyleControls;
